export default "__VITE_ASSET__287d458b__"